import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ClientGeneralParams } from "../features/admin/generalParams/types";
import type { RootState } from "./store";
import { LanguageEnum } from "../features/admin/generalParams/types/enum";

export interface ClientParamsState {
    data: ClientGeneralParams;
    errors: {
        [key: string]: string | undefined;
    };
    isSubmitting: boolean;
}

const initialState: ClientParamsState = {
    data: {
        language: LanguageEnum.Catalan,
        notifyIfExportRequests: false,
        isRequiredResponsibleOnClaimClosure:false,
    },
    errors: {},
    isSubmitting: false
};

const GeneralParamsFormSlice = createSlice({
    name: "GeneralParamsForm",
    initialState,
    reducers: {
        setError(state, action: PayloadAction<{ field: keyof ClientGeneralParams | string; message: string | undefined }>) {
            const { field, message } = action.payload;
            state.errors[field] = message;
        },
        clearErrors(state) {
            state.errors = {};
        },
        setGeneralParamsForm(state, action: PayloadAction<Partial<ClientGeneralParams>>) {
            Object.assign(state.data, action.payload);  
        }
    }
});

export const {
    setError,
    clearErrors,
    setGeneralParamsForm
} = GeneralParamsFormSlice.actions;

export const selectClientParamsData = (state: RootState) => state.clientParamsForm.data;

const getLogoExtensionFromContentType = (contentType?: string) => {
    switch ((contentType ?? "").toLowerCase()) {
        case "image/png":
            return "png";
        case "image/jpeg":
        case "image/jpg":
            return "jpg";
        case "image/webp":
            return "webp";
        case "image/svg+xml":
            return "svg";
        default:
            return "";
    }
};

export const selectClientParamsLogoFileName = (state: RootState) => {
    const { logoFile, logo, logoFileName, logoContentType } = state.clientParamsForm.data;

    if (logoFile?.name) return logoFile.name;
    if (!logo) return "";

    if (logoFileName) return logoFileName;

    const ext = getLogoExtensionFromContentType(logoContentType);
    return ext ? `logo.${ext}` : "logo";
};

export default GeneralParamsFormSlice.reducer;
